<template>
  <nav class="c-nav" ref="menu">
    <a href="/" class="c-nav__logo hide-on-pad"></a>
    <div class="overlay show-on-pad" @click="TOGGLE_MENU"></div>
    <div class="nav-wrapper c-layout">
      <div class="close-btn show-on-pad" @click="TOGGLE_MENU"></div>
      <div class="logout show-on-pad" @click="logout" v-if="userInfo">{{userInfo.user.name}} {{$t('header.logout')}}</div>
      <!-- <div class="search-input-block show-on-pad">
        <input type="text" name="" id="">
        <Icon type="search"></Icon>
        <label for="">搜寻</label>
      </div> -->
      <div class="lang-list show-on-pad-flex">
        <div 
          class="lang-item"
          :class="{ active: $i18n.locale==item.code }" 
          v-for="(item,index) in getlangList" 
          :key="'lang_item_'+index"
          @click="handleChangeLang(item.code)"
        >
          {{ item.title }}
        </div>
      </div>
      <router-link :to="{name:'newGoods'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item1') }}</span>
      </router-link>
      <router-link :to="{name:'activity'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item2') }}</span>
      </router-link>
      <router-link :to="{name:'goods'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item3') }}</span>
        <div class="container-custom">
          <div class="container-custom__wrap c-layout">
            <div class="link-item" v-for="(item,key,index) in goods" :key="index">
              <p class="title">{{ getGoodsCateName(key) }}</p>
              <router-link
                :to="{name:'goods',query:{category:item1.id}}"
                v-for="(item1,key1,index1) in item"
                :key="index1"
              >{{item1.name}}</router-link>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{ name:'customAbout' }" class="nav-item">
        <span class="nav-text">{{ $t('nav.item4') }}</span>
        <div class="container-custom">
          <div class="container-custom__wrap c-layout">
            <div class="link-item">
              <router-link :to="{ name:'customAbout' }" class="title">{{ $t('nav.item5') }}</router-link>
            </div>
            <div class="link-item">
              <router-link :to="{ name:'customIntro' }" class="title">{{ $t('nav.item6') }}</router-link>
            </div>
            <div class="link-item">
              <router-link :to="{ name:'customForm' }" class="title">{{ $t('nav.item7') }}</router-link>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{name:'guide', query: getGuideQuery }" class="nav-item">
        <span class="nav-text">{{ $t('nav.item8') }}</span>
        <div class="container-custom">
          <div class="container-custom__wrap c-layout">
            <div class="link-item" v-for="(item,key,index) in guide" :key="index">
              <p class="title">{{ getGuideCateName(key) }}</p>
              <router-link
                :to="{name:'guide',query:{category:item1.id}}"
                v-for="(item1,key1,index1) in item"
                :key="index1"
              >{{item1.name}}</router-link>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{name:'location'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item9') }}</span>
      </router-link>
      <router-link :to="{name:'share'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item10') }}</span>
      </router-link>
      <router-link :to="{name:'QAList'}" class="nav-item">
        <span class="nav-text">{{ $t('nav.item11') }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import { get,del } from "../../utils/localStorage";
import { getGoodsInd, getGuideInd } from "@/api";
export default {
  data() {
    return {
      goods: "",
      guide:""
    };
  },
  computed: {
    ...mapState(['menuOpen','userInfo']),
    getGuideQuery() {
      if(this.guide) {
        const keys = Object.keys(this.guide);
        const keys2 = Object.keys(this.guide[keys[0]]);
        return { category: keys2[0] };
      }
      return '';
    },
    getlangList() {
      console.log(Object.values(this.$i18n.messages));
      const list = Object.values(this.$i18n.messages).map(item => {
        return { title:item.locale_title, code:item.locale_code };
      });
      console.log('getLangList');
      console.log(list);
      return list;
    },
  },
  watch: {
    menuOpen(newD,oldD) {
      console.log(newD);
      if(newD) {
        this.$refs.menu.style.display = 'block';
        setTimeout(() => {
          this.$refs.menu.classList.add('open');
        }, 50);
      }else{
        this.$refs.menu.classList.remove('open');
        setTimeout(() => {
          this.$refs.menu.style.display = 'none';  
        }, 1000);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const _this = this;
        getGoodsInd({},_this).then((res) => {
          this.goods = res.ind;
          this.SET_GOODS_IND(res.ind);
        });
        getGuideInd({},_this).then((res) => {
          this.guide = res.ind;
          this.SET_GUIDE_IND(res.ind);
        });
      }, 1000);
    })
  },
  methods: {
    ...mapMutations(['TOGGLE_MENU','SET_GOODS_IND','SET_GUIDE_IND']),
    logout(){
      this.TOGGLE_MENU();
      del('token');
      del('userInfo');
      this.$store.commit('CLEAN_USER_INFO');
      this.$router.push({ name: 'register', query: { type: 'login' } });
    },
    handleChangeLang(code) {
      this.showLangList = false;
      localStorage.setItem('language',code);
      return history.go(0);
    },
    getGoodsCateName(cate) {
      switch(String(cate)) {
        case '1': 
          return this.$t('nav.item3_1');
          break;
        case '2': 
          return this.$t('nav.item3_2');
          break;
        case '3': 
          return this.$t('nav.item3_3');
          break;
      }
    },
    getGuideCateName(cate) {
      switch(String(cate)) {
        case '1': 
          return this.$t('nav.item8_1');
          break;
        case '2': 
          return this.$t('nav.item8_2');
          break;
        case '3': 
          return this.$t('nav.item8_3');
          break;
      }
    }
  },
  components: {},
};
</script>

<style lang='less'>
.c-nav {
  padding-top: 28px;
  position: relative;
  border-bottom: 1px solid #bbb;
  @media (max-width: 992px) {
    display: none;
    position: fixed;
    height: calc(100% - 46px);
    top: 46px;
    z-index: 1000;
    width: 100%;
    padding-top: 0;
  }
  a {
    text-decoration: none;
    color: var(---unnamed-color-707070);
  }
  .overlay {
    background: rgba(0,0,0,.6);
    position: absolute;
    height: 100%;
    width: 100%;
    display: none !important;
  }
  .close-btn {
    align-self: flex-end;
    position: relative;
    width: 26px;
    height: 26px;
    &::before,&::after {
      content: '';
      position: absolute; 
      height: 2px;
      width: 100%;
      background: #656565;
      transform: rotate(45deg);
      top: 15px;
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  .search-input-block {
    background: #F9F9F9;
    position: relative;
    margin-top: 20px;
    & /deep/ .cloud-icon {
      pointer-events: none;
      position: absolute;
      top: 50%;
      left: 49%;
      transform: translate(-100%,-50%);
      transition: .5s;
      svg {
        fill: #656565;
      }
    }
    label {
      position: absolute;
      pointer-events: none;
      top: 50%;
      left: 51%;
      transform: translate(-0%,-50%);
    }
    input {
      width: 100%;
      border: unset;
      background: unset;
      padding: 15px;
      padding-left: 40px;
      &:focus+.cloud-icon {
        left: 10px;
        transform: translate(-0%,-50%);
      }
      &:focus~label {
        display: none;
      }
    }
  }
  .nav-wrapper {
    display: flex;
    justify-content: space-around;
    padding: 0 55px;
    color: var(---unnamed-color-707070);
    font-size: 16px;
    line-height: 24px;
    background: white;
    @media (max-width: 992px) {
      display: flex;
      flex-direction: column;
      position: absolute;
      justify-content: flex-start;
      width: 50%;
      min-width: 250px;
      height: 100%;
      padding: 20px 20px 0 20px;
      box-shadow: 5px 5px 5px 2px rgba(0,0,0,.2);
      transition: 1s;
      transform: translateX(-110%);
    }
  }
  .router-link-active {
    .nav-text {
      color: var(---unnamed-color-ff5214);
    }
    .nav-text::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-bottom: 5px solid var(---unnamed-color-ff5214);
      @media (max-width: 992px) {
        width: 0;
      }
    }
  }
  .nav-item:hover {
    .container-custom {
      opacity: 1;
      z-index: 6;
      @media (max-width: 992px) {
        display: none;
      }
    }
    .nav-text {
      color: var(---unnamed-color-ff5214);
    }
    .nav-text::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-bottom: 5px solid var(---unnamed-color-ff5214);
      @media (max-width: 992px) {
        width: 0;
      }
    }
  }
  .nav-item {
    display: block;
    height: 92px;
    line-height: 92px;
    @media (max-width: 992px) {
      position: relative;
      height: 50px;
      line-height: 50px;
      padding: 10px 20px;
      border-bottom: 1px solid #ddd;
      &::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:none;%7D.b%7Bfill:%23656565;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M24,0H0V24H24Z'/%3E%3Cpath class='b' d='M8,7.351,9.351,6l5.75,5.75L9.351,17.5,8,16.149l4.389-4.4Z' transform='translate(0.75 0.25)'/%3E%3C/svg%3E");
        width: 32px;
        height: 32px;
        position: absolute;
        right: 0;
        top: 16px;
      }
    }
    .nav-text {
      display: block;
      position: relative;
      cursor: pointer;
      height: 100%;
    }
    .container-custom {
      position: absolute;
      opacity: 0;
      transition: all 0.3s;
      z-index: -1;
      left: 0;
      top: 184px;
      width: 100%;
      background: var(--unnamed-color-ffffff);
      padding-top: 52px;
      padding-bottom: 52px;
      border-top: 2px solid var(---unnamed-color-b7b7b7);
      border-bottom: 2px solid var(---unnamed-color-b7b7b7);
      @media (max-width: 992px) {
        display: none;
      }
      .container-custom__wrap {
        display: flex;

        .link-item:first-child {
          padding-left: 0;
        }
        .link-item:last-child {
          border-right: none;
        }
        .link-item {
          min-height: 150px;
          // padding-right: 35px;
          padding-left: 35px;
          min-width: 300px;
          border-right: 1px solid var(---unnamed-color-b7b7b7);
          .title {
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: var(--unnamed-character-spacing-0);
            color: var(--unnamed-color-111111);
          }
          a {
            display: block;
            cursor: pointer;
            margin-bottom: 6px;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: var(--unnamed-character-spacing-0);
            color: var(---unnamed-color-707070);
          }
          a:hover {
            color: var(---unnamed-color-ff5214);
          }
        }
      }
    }
  }

  .c-nav__logo {
    display: block;
    margin: 0 auto;
    width: 218px;
    height: 64px;
    background: url("./images/LOGO-01@2x.png") no-repeat;
    background-size: contain;
    background-position: center center;
  }

  &.open {
    @media (max-width: 992px) {
      .overlay {
        display: block !important;
      }
      .nav-wrapper {
        transform: translateX(0%);
      }
    }
  }
  .logout {
    position: absolute;
    top: 24px;
    cursor: pointer;
  }
  .lang-list {
    display: flex;
    margin-top: 10px;
    .lang-item {
      padding-right: 10px;
      &:nth-last-child(1) {
        padding-right: 0;
      }
      &.active {
        color: orange;
      }
    }
  }
}
</style>
